import ActivateBillingAccountRequest from './ActivateBillingAccountRequest'

export default class GoLiveCreateRequest {
    FirstName: string | undefined;

    LastName: string | undefined;

    Website: string | undefined;

    ApplicationName: string | undefined;

    UsageDesc: string | undefined;

    IntegrationType: string | undefined;

    ClientList: string | undefined;

    PlatformLanguage: string | undefined;
    
    BusinessName: string | undefined;

    BillingDetails: ActivateBillingAccountRequest | undefined;
}